export const GOOGLE_CLICK_ID_NAME = 'gclid';
export const GOOGLE_CLICK_DATE = 'gclidDate';
export const GOOGLE_CLICK_ID_REGEX = new RegExp(`(?:${GOOGLE_CLICK_ID_NAME}=)([a-zA-Z0-9_\\-]+)`);
export const GOOGLE_CLICK_ID_DATE_REGEX = new RegExp(`(?:^|; )${GOOGLE_CLICK_DATE}=([^;]*)`);

export const GOOGLE_CLICK_ID_EXPIRY_DAYS = 90;
